'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');

module.exports = function () {
    $('.country-selector a').click(function (e) {
        e.preventDefault();
        var action = $('#customRedirectAction').val() || $('.page').data('action');
        var localeCode = $(this).data('locale');
        var localeCurrencyCode = $(this).data('currencycode');
        var queryString = $('.page').data('querystring');
        var url = $('.country-selector').data('url');

        $.ajax({
            url,
            type: 'get',
            dataType: 'json',
            data: {
                code: localeCode,
                queryString,
                CurrencyCode: localeCurrencyCode,
                action
            },
            success(response) {
                $.spinner().stop();
                if (response && response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                }
            },
            error() {
                $.spinner().stop();
            }
        });
    });

    keyboardAccessibility(
        '.navbar-header .country-selector',
        {
            40($countryOptions) {
                // down
                if ($(this).is(':focus')) {
                    $countryOptions.first().focus();
                } else {
                    $(':focus').next().focus();
                }
            },
            38($countryOptions) {
                // up
                if ($countryOptions.first().is(':focus') || $(this).is(':focus')) {
                    $(this).focus();
                    $(this).removeClass('show');
                } else {
                    $(':focus').prev().focus();
                }
            },
            27() {
                // escape
                $(this).focus();
                $(this).removeClass('show').children('.dropdown-menu').removeClass('show');
            },
            9() {
                // tab
                $(this).removeClass('show').children('.dropdown-menu').removeClass('show');
            }
        },
        function () {
            if (!$(this).hasClass('show')) {
                $(this).addClass('show');
            }
            return $(this).find('.dropdown-country-selector').children('a');
        }
    );

    $('.navbar-header .country-selector').on('focusin', function () {
        $(this).addClass('show').children('.dropdown-menu').addClass('show');
    });
};
